import { render, staticRenderFns } from "./price-calculation-save.vue?vue&type=template&id=4b0f1e2a"
import script from "./price-calculation-save.vue?vue&type=script&lang=js"
export * from "./price-calculation-save.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports